import { ColDef, ICellRendererParams } from 'ag-grid-community';
import {
  ColSize,
  createDateHasAllTimeCol,
  createDetailButtonColV2,
  createIdCol,
  createTypoCol,
} from '@/src/helpers/agColumnHelper';
import Badge from '@/components/atom/Badge';
import { PushAlarmInfoDto } from '@/src/models/PushAlarmInfoDto';
import { getStatusBadgeProps } from '@/src/pages/pushAlarm/badge';

export const pushAlarmInfoListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateHasAllTimeCol({
    field: 'reservationTime',
    size: 'md',
    headerName: '발송 일시',
  }),
  createTypoCol({
    field: 'pushCategoryTypeKr',
    size: 'sm',
    headerName: '카테고리',
  }),
  createTypoCol({
    field: 'pushAlarmTitle',
    size: 'md',
    headerName: '제목',
  }),
  createTypoCol({
    field: 'pushAlarmContent',
    size: 'lg',
    headerName: '내용',
  }),
  {
    headerClass: 'ag-right-aligned-cell',
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    field: 'pushProgressStatus',
    width: 120,
    minWidth: 120,
    maxWidth: 120,
    cellRenderer: ({ data }: ICellRendererParams<PushAlarmInfoDto>) => {
      return (
        <Badge
          {...getStatusBadgeProps(data?.pushProgressStatus ?? 'scheduled')}
        />
      );
    },
    headerName: '발송 상태',
  },
  {
    field: 'pushResult',
    headerClass: 'ag-right-aligned-cell',
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    ...ColSize.sm,
    cellRenderer: ({ data }: ICellRendererParams<PushAlarmInfoDto>) => {
      const isScheduled = data?.pushProgressStatus === 'scheduled';
      if (isScheduled) return '-';

      const totalCount = data?.pushAlarmTotalCount || 0;
      const successCount = data?.pushAlarmSuccessCount || 0;
      const successPercent = data?.pushAlarmInformationSuccessPercent || 0;

      return `${successCount}/${totalCount}(${successPercent}%)`;
    },
    headerName: '발송 결과',
  },
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '등록 일시',
  }),
  {
    field: 'administrator',
    headerClass: 'ag-right-aligned-cell',
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    ...ColSize.sm,
    cellRenderer: ({ data }: ICellRendererParams<PushAlarmInfoDto>) => {
      return data?.administrator?.name || '-';
    },
    headerName: '등록 관리자',
  },
  createDetailButtonColV2(onDetailClick),
];
